<template>
    <div class="pt-loading-tips" v-if="tipObject?.tips">
        <p class="loading-tip">
            <span class="loading-tip-icon">
                <pt-icon icon="pt-icon-tips" :icon-style="{ width: '24px', height: '24px' }"></pt-icon>
            </span>
            <span v-html="tipObject?.tips"></span>
        </p>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import PtIcon from '../../icon';
export default defineComponent({
    name: 'LoadingTips',
    components: { PtIcon },
    props: {
        tips: Array,
    },
    setup(props) {
        const tipObject = computed(() => {
            if (props.tips && Array.isArray(props.tips)) {
                const len = props.tips.length;
                const radom = Math.floor(Math.random() * len);
                return props.tips[radom] || props.tips[0];
            }
            return props.tips;
        });
        return {
            tipObject,
        };
    },
});
</script>

<style lang="scss">
@import '../../styles/colors';
.pt-loading-tips {
    margin: 20px auto 0;
    word-break: break-word;
    display: flex;
    justify-content: center;
    .loading-tip {
        font-size: 16px;
        color: $pt-black-900;
        max-width: 532px;
        font-weight: 500;
        padding: 16px 24px;
        background-color: rgba(244, 245, 247, 0.6);
        border: 1px solid $pt-black-30;
        border-radius: 4px;
        text-align: left;
        position: relative;
        .loading-tip-icon {
            width: 32px;
            height: 32px;
            padding: 3px;
            position: absolute;
            top: -12px;
            left: -12px;
            background-color: $pt-white;
            border-radius: 50%;
            border: 1px solid #979797;
            svg {
                width: 24px;
                height: 24px;
            }
        }
    }
}
</style>
